import { Copyable } from 'components/copyable';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/table';
import { ContentFilterGroupQuery } from 'graphql/types';
import { useTable, Column } from 'react-table';

type FilterItemsTableData = {
  id: string;
  title: string;
};

const contentFilterItemsTableColumns: Column<FilterItemsTableData>[] = [
  {
    Header: 'ID',
    accessor: 'id',
    Cell: (cell) => {
      return (
        <Copyable text={cell.value}>
          {(copied) => (
            <pre className="text-sm cursor-pointer text-slate-500">
              {copied ? 'Copied' : cell.value.slice(-6)}
            </pre>
          )}
        </Copyable>
      );
    },
  },
  {
    Header: 'Title',
    accessor: 'title',
  },
];

export const FilterItemsTable = ({
  filterItems,
}: {
  filterItems:
    | NonNullable<ContentFilterGroupQuery['contentFilterGroup']>['filterItems']
    | undefined;
}) => {
  const tableData = filterItems?.map((item) => ({
    id: item.id,
    title: item.title,
  }));

  const tableInstance = useTable({
    columns: contentFilterItemsTableColumns,
    data: tableData ?? [],
  });

  return (
    <Table tableInstance={tableInstance}>
      <TableHead />
      <TableBody>
        {tableInstance.rows.map((row) => {
          tableInstance.prepareRow(row);
          return (
            <TableRow key={row.id} row={row}>
              {row.cells.map((cell) => (
                <TableCell
                  key={`${cell.row.original.id}-${cell.column.id}`}
                  cell={cell}
                />
              ))}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
